const LANGUAGE_MAP: Record<string, string> = {
  en: 'en-us',
  pt: 'pt-br',
  zh: 'zh-cn',
  de: 'de',
  ar: 'ar',
  es: 'es',
  ko: 'ko',
  ja: 'ja',
};

export function eligibleProjectLanguagesFromApproved(approved: Array<string | null> | null | undefined): string[] {
  if (!approved) {
    return [];
  }

  const mapped = approved.reduce<string[]>((accum, lang) => {
    if (!lang) {
      return accum;
    }
    const firstTwoLangChars = lang.substring(0, 2);
    if (Object.prototype.hasOwnProperty.call(LANGUAGE_MAP, firstTwoLangChars)) {
      accum.push(LANGUAGE_MAP[firstTwoLangChars]);
    }
    return accum;
  }, []);

  return [...new Set(mapped)];
}
